import React from 'react';
import { UpsellProducts } from 'features/typesense/components';
import { useQueryOrder } from 'helpers/hooks/useQueryOrder';

const UpsellProductsTastic = ({ data }) => {
  const order = useQueryOrder();

  if (order?.lineItems && order.lineItems.length > 0) {
    return (
      <UpsellProducts
        title={data?.title}
        product_results={[
          {
            type: 'relation',
            related_products: order.lineItems.map((lineItem) => ({
              sku: lineItem.variant.sku,
              productId: lineItem.productId,
              gender: lineItem.variant.attributes?.['gender']?.key,
            })),
          },
        ]}
        inCheckout={true}
      />
    );
  }

  return null;
};

export default UpsellProductsTastic;
